// Auto-select subscription option by default for Seal Subscriptions
document.addEventListener('DOMContentLoaded', function() {
  let hasAutoSelected = false;
  
  // Function to select subscription option
  function selectSubscriptionByDefault() {
    // Only auto-select once, don't interfere with manual switching
    if (hasAutoSelected) return;
    
    // Find the subscription radio button (not the one-time purchase)
    const subscriptionRadio = document.querySelector('input.sls-option[data-type="subscription"]');
    
    if (subscriptionRadio && !subscriptionRadio.checked) {
      // Click the subscription option to select it
      subscriptionRadio.click();
      
      // Also trigger the parent container click for proper activation
      const subscriptionContainer = subscriptionRadio.closest('.sls-selling-plan-group-first-line');
      if (subscriptionContainer) {
        subscriptionContainer.click();
      }
      
      // Mark as auto-selected so we don't interfere with manual changes
      hasAutoSelected = true;
    }
  }
  
  // Run immediately
  selectSubscriptionByDefault();
  
  // Also run after a short delay to catch dynamically loaded content
  setTimeout(selectSubscriptionByDefault, 100);
  setTimeout(selectSubscriptionByDefault, 500);
  setTimeout(selectSubscriptionByDefault, 1000);
});
